import type { IconSvgObject } from './types';

const DeskIcon: IconSvgObject = [
  ["path", { d: "M5 17V22M19 17V22", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 17V20M16 17V20", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 8V4C7 2.89543 7.89543 2 9 2H15C16.1046 2 17 2.89543 17 4V8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M2 8H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M3 8V15C3 16.1046 3.89543 17 5 17H19C20.1046 17 21 16.1046 21 15V8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default DeskIcon;
